// BR
import BR_Level_00 from "./BR/Level_00_AGENT";
import BR_Level_10 from "./BR/Level_10_AGENT_MANAGER";
import BR_Level_20 from "./BR/Level_20_REGIONAL_MANAGER";
import BR_Level_30 from "./BR/Level_30_SALES_DIRECTOR";
// EN
import EN_Level_00 from "./EN/Level_00_AGENT";
import EN_Level_10 from "./EN/Level_10_AGENT_MANAGER";
import EN_Level_20 from "./EN/Level_20_REGIONAL_MANAGER";
import EN_Level_30 from "./EN/Level_30_SALES_DIRECTOR";

// ES
import ES_Level_00 from "./ES/Level_00_AGENT";
import ES_Level_10 from "./ES/Level_10_AGENT_MANAGER";
import ES_Level_20 from "./ES/Level_20_REGIONAL_MANAGER";
import ES_Level_30 from "./ES/Level_30_SALES_DIRECTOR";

import DEFAULT_AGREEMENT from "./Default";

export const Agreements = {
  br: {
    "00": BR_Level_00,
    "10": BR_Level_10,
    "20": BR_Level_20,
    "30": BR_Level_30,
  },

  en: {
    "00": EN_Level_00,
    "10": EN_Level_10,
    "20": EN_Level_20,
    "30": EN_Level_30,
  },
  
  es: {
    "00": ES_Level_00,
    "10": ES_Level_10,
    "20": ES_Level_20,
    "30": ES_Level_30,
  },
  DEFAULT: DEFAULT_AGREEMENT,
};
